angular.module("vgresiduos").controller("IbamaRappIntegrationCreateCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "declaracoes/ibama-rapp/integracao/novo");
		};
	}
]);
